import React, { useCallback, useState, useContext } from "react";
import { Modal, Box, Typography, Tooltip, Button } from "@mui/material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import Loader from "../../component/loading-screen/Loader";
import ModalFooter from "../../modals/ModalFooter";
import Spinner from "../../component/loading-screen/Spinner";
import AuthContext from "../../store/AuthContext";
const ResignTask = ({ data, refresh, disabled }) => {
  const [open, setOpen] = useState(false);
  const [updaLoading, setUpdateLoading] = useState(false);
  const [request, setRequest] = useState(false);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  console.log("ResignTask data:", data);
  const [formData, setFormData] = useState({
    id: data.id,
    assigned_name: user.name,
    // project_id: data.project_id,
    // category: data.category,
    // start_date: data.start_date,
    // end_date: data.end_date,
    // assigned_to: data.assigned_to,
    // priority: data.priority,
    // description: data.description,
    // status: data.status,
  });

  const handleOpen = () => {
    setFormData({
      id: data.id,
      assigned_name: user.name,
      // project_id: data.project_id,
      // category: data.category,
      // start_date: data.start_date,
      // end_date: data.end_date,
      // assigned_to: data.assigned_to,
      // priority: data.priority,
      // description: data.description,
      // status: data.status,
    });
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const assignTask = useCallback(async () => {
    setRequest(true);
    postJsonData(
      `${ApiEndpoints.ASIGN_TO_TASK}`,
      formData,
      setUpdateLoading,
      (res) => {
        okSuccessToast(res.data.message);
        setRequest(false);
        setOpen(false);
        refresh();
      },
      (error) => {
        apiErrorToast(error);
        setOpen(false);
      }
    );
  }, [data.id, formData, refresh]);

  const handleSubmit = (e) => {
    e.preventDefault();
    assignTask();
  };

  return (
    <>
      <Tooltip title="Assign Task">
        <Button
          sx={{
            backgroundColor: "rgb(153, 140, 140)", // Red background
            color: "#fff", // White text for contrast
            "&:hover": {
              backgroundColor: "rgb(200, 30, 30)", // Darker red on hover
            },
            "&.Mui-disabled": {
              backgroundColor: "#ccc", // Grey when disabled
              color: "#888",
            },
          }}
          onClick={handleOpen}
          disabled={disabled}
          variant="contained"
        >
          OPT
        </Button>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Spinner loading={request} />
          <ModalHeader
            title="Assign Task"
            handleClose={handleClose}
            subtitle="Easily Assign Task"
          />
          <Typography
            id="delete-confirmation-modal"
            variant="h6"
            fontWeight="bold"
          >
            Are you sure you want to assign this task?
          </Typography>
          <Box>
            <ModalFooter
              form="assign-task"
              request={request}
              btn="Assign Task"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ResignTask;
